<template>
  <div>
    <Swiper :data="swiperList" v-if="swiperList.length > 0" />
    <div class="category-view">
      <div class="model-name">类目概览</div>
      <div class="model-name-en">Category overview</div>
      <div class="category-list">
        <div class="category-item" v-for="(item, index) in categoryList" :key="index" @click="goCategory(item)">
          <el-image :src="item.image" lazy fit="cover" class="category-image"></el-image>
          <div class="category-item-name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="project-dynamic gray-bg">
      <div class="model-name">项目动态</div>
      <div class="model-name-en">Project News</div>
      <div class="project-dynamic-content">
        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in dynamicList" :key="index">
            <div class="item-img" v-lazy:background-image="item.img || placeholderImg"></div>

            <p class="item-list-title more-t-2">{{item.title}}</p>
            <p class="item-list-content">{{item.brief}}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'article', params: { ...item }}"
              >
                <img src="../../assets/img/sanjiao.png" />
                <span>查看更多</span>
              </router-link>
            </div>
          </div>
        </div>
        <!-- <el-row :gutter="20">
          <el-col :span="10" :offset="2" v-for="(item, index) in dynamicList" :key="index">
            <div class="dynamic-item">
              <div class="dynamic-item-time">{{parseTime(item.createTime, '{y}-{m}-{d}')}}</div>
              <div class="dynamic-item-name more-t-2" @click="toArticle(item)" :title="item.title">{{item.title}}</div>
              <div class="dynamic-item-image">
                <img src="https://aimg8.dlssyht.cn/u/1201178/ueditor/image/601/1201178/1608086522166994.png" class="imagecover" />
              </div>
              <div class="dynamic-item-desc more-t-2">{{item.brief}}</div>
            </div>
          </el-col>
        </el-row> -->
      </div>
      <div class="link-btn">
        <router-link to="/dynamic">
          <img src="@/assets/images/link-btn.png" />
        </router-link>
      </div>
    </div>
    <!-- <div class="project-activity">
      <div class="model-name">项目活动</div>
      <div class="model-name-en">Project activities</div>
      <div class="category-list">
        <div class="category-item" v-for="(item, index) in activities" :key="index">
          <el-image :src="item.image" lazy></el-image>
          <div class="category-item-name">{{item.name}}</div>
        </div>
      </div>
      <div class="link-btn">
        <img src="@/assets/images/link-btn.png" />
      </div>
    </div> -->
    <div class="vr-model">
      <div class="model-name">VR总览</div>
      <div class="model-name-en">VR overview</div>
      <div class="vr-model-content" id="vrPre">
        <iframe :src="vrSrc" width="100%" height="100%" frameborder="0" />
      </div>
    </div>
    <div class="project-industry gray-bg">
      <div class="model-name">项目产业</div>
      <div class="model-name-en">Project industry</div>
      <div class="project-industry-content">
        <Accordion :data="accordionList" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import _ from 'lodash'
import { getCarousel, loadYxTitle } from '@/api/api'
import { placeholderImg } from '@/config'
import {
  parseTime
} from '@/utils/index'
import Swiper from './components/Swiper'
import Accordion from '@/components/Accordion'
export default {
  components: {
    Swiper,
    Accordion
  },
  data() {
    return {
      placeholderImg,
      vrOffsetTop: 0,
      // vrSrc: 'https://vr.gdyfpt.com/static/tour.html?id=59',
      vrSrc: '',
      categoryList: [
        {
          name: '景区VR',
          image: require('@/assets/images/vr.jpg'),
          url: 'https://vr.gdyfpt.com/static/tour.html?id=59'
        },
        {
          name: '新闻动态',
          image: require('@/assets/images/news.png'),
          route: '/dynamic'
        }
      ],
      dynamicList: [],
      accordionList: [],
      // activities: [
      //   {
      //     name: '耕耘树艺',
      //     image: require('@/assets/images/overview.png')
      //   }
      // ],
      // 幻灯片
      swiperList: [],
    }
  },
  mounted() {
    this.vrOffsetTop = $('#vrPre').offset().top - $(window).height()
    window.addEventListener('scroll', this.handleScroll)

    this.loadCarousel()
    this.loadArticles()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    parseTime,
    loadCarousel() {
      getCarousel({
        page: 0,
        size: 20
      }).then(res => {
        var data = res.content.filter(item => {
          return item.isShow == 0
        })
        data = _.sortBy(data, (o) => {
          return o.carouselSort
        })
        // carouselSort
        this.swiperList = data
      })
    },
    loadArticles() {
      loadYxTitle().then(res => {
        var data = res.content.find(item => {
          return item.titleType == 1
        })
        var data2 = res.content.find(item => {
          return item.titleType == 6
        })
        if(data) {
          var list = data.articleTypeList.find(item => {
            return item.articleDetailList
          })
          this.dynamicList = list ? list.articleDetailList.splice(0, 3) : []
        }
        if(data2 && data2.articleTypeList.length > 0) {
          var detailList = data2.articleTypeList[0].articleDetailList
          if(detailList) {
            this.accordionList = detailList
          }
        }
        this.$nextTick(() => {
          this.vrOffsetTop = $('#vrPre').offset().top - $(window).height()
        })
      })
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop > this.vrOffsetTop && !this.vrSrc) {
        this.vrSrc = 'https://vr.gdyfpt.com/static/tour.html?id=59'
      }
    },
    toArticle(item) {
      this.$router.push({
        name: 'article',
        params: {
          ...item
        }
      })
    },
    goCategory(item) {
      if(item.route) {
        this.$router.push({
          path: item.route
        })
      } else if(item.url) {
        window.open(item.url)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/styles/color.scss";
  .category-view {
    padding-top: 120px;
  }
  .category-list {
    text-align: center;
    font-size: 0;
    overflow: hidden;
    padding: 80px 0;
    .category-item {
      width: 380px;
      height: 240px;
      display: inline-block;
      margin-right: 30px;
      position: relative;
      cursor: pointer;
      vertical-align: middle;
      &:last-child {
        margin: 0;
      }
      .category-image {
        width: 100%;
        height: 100%;
      }
      .category-item-name {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 42px;
        line-height: 42px;
        background: rgba(57, 57, 57, .6);
        text-align: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
  .project-dynamic {
    padding: 40px 0 80px;
    .project-dynamic-content {
      padding: 80px 0 100px;
      width: 1200px;
      margin: 0 auto;
    }
    .dynamic-item {
      .dynamic-item-time {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 16px;
        color: #999999;
        margin-bottom: 14px;
      }
      .dynamic-item-name {
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .dynamic-item-image {
        width: 100%;
        height: 260px;
        margin-bottom: 18px;
      }
      .dynamic-item-desc {
        padding-top: 20px;
        border-top: 1px solid #ECECEC;
        line-height: 20px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #999999;
      }
    }
  }
  .project-activity {
    padding: 40px 0 80px;
  }
  .vr-model {
    padding: 40px 0 120px;
    .vr-model-content {
      width: 1200px;
      height: 768px;
      margin: 80px auto 0;
    }
  }
  .project-industry {
    padding: 120px 0 180px;
    .project-industry-content {
      width: 1200px;
      height: 572px;
      margin: 0 auto;
      padding-top: 40px;
    }
  }
  .link-btn {
    width: 150px;
    height: 30px;
    cursor: pointer;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .gray-bg {
    background: #F8F8F8;
  }
  .content-nav-item {
    width: 1070px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    //border: 1px solid blue;
    .item-list {
      width: 330px;
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 10px 10px;
      border: 1px solid $primary-color;
      &:hover {
        border: 1px solid #fff;
        box-shadow: 0 0 5px 2px #bfd3e0;
      }
      .item-img {
        width: 300px;
        height: 210px;
        background-color: #cecece;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-origin: content-box;
      }
      &-title {
        width: 300px;
        height: 60px;
        color: #15669e;
        font-size: 22px;
        padding: 0 10px;
        margin: 20px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        border-left: 1px solid #15669e;
      }
      &-content {
        width: 273px;
        height: 100px;
        font-size: 14px;
        color: gray;

        // 文本长度处理 begin
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
        // 文本长度处理 ending
      }
      &-more {
        width: 273px;
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
        }
        span {
          color: #e13834;
          padding: 0 5px;
        }
      }
    }
  }
</style>